import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ServerUrlService } from './server-url.service';

@Injectable({
    providedIn: 'root'
})
export class LocalService {
    private headers: any
    constructor(private httpClient: HttpClient, private serverUrl: ServerUrlService) {
        this.headers = {
            headers: {
                'Content-Type': 'application/json'
            }
        }
    }

    getLocais() {
        const url = this.serverUrl.getUrl()
        return this.httpClient.get(url + '/locais')
    }

}
